// src/modals/WhyGoPremium.jsx
// Phase 37 Plan 06 — extracted from src/App.jsx (was lines 9062-~9192 pre-Plan-37-06).
//
// Scope: FF-01 — Why Go Premium modal. Reads `?source=` query parameter (and the
// `tend:premium-source` window event) to attribute upgrade prompts back to their
// trigger (D-09). Lists premium-only AI features and the free-tier feature set.

import { useState, useEffect } from 'react';
import { X, Check } from 'lucide-react';

export default function WhyGoPremium({onClose}) {
  // D-09: per-trigger source attribution — reads ?source= query param or tends:premium-source event
  const SOURCE_COPY_MAP = {
    plantLimit:    "You've nearly filled your free garden — Premium gives you room to grow.",
    unknownPlant:  "Tend couldn't find that plant in its database. Premium unlocks AI to add any plant.",
    sickPlant:     "Something's not right with your plant. Premium gives you AI-powered advice.",
    deviceChange:  "You're on a new device — Premium keeps your garden synced everywhere.",
    seasonalNudge: "It's a great time to get more from your garden. Premium does the thinking for you.",
  };
  const [sourceTrigger, setSourceTrigger] = useState(() => {
    try { const u = new URL(window.location.href); return u.searchParams.get('source') || null; } catch { return null; }
  });
  useEffect(() => {
    const handler = (e) => setSourceTrigger(e.detail || null);
    window.addEventListener('tend:premium-source', handler);
    return () => window.removeEventListener('tend:premium-source', handler);
  }, []);
  const intro = sourceTrigger && SOURCE_COPY_MAP[sourceTrigger];

  const premiumItems = [
    "Ask Tend AI chat (personalised garden advice)",
    "AI-generated care schedules for every plant",
    "Bulk import with AI plant validation",
    "AI colour data enrichment",
    "Conversational plant adding",
  ];
  const freeItems = [
    "Full plant directory and management",
    "Monthly and yearly care calendars",
    "Activity and supplies tracking",
    "Living Colours palette view",
    "Print-friendly schedules",
  ];
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"var(--c-bg)",borderRadius:16,padding:28,maxWidth:520,width:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.2)",position:"relative"}}>
        <button onClick={onClose} style={{position:"absolute",top:16,right:16,background:"none",border:"none",cursor:"pointer",color:"var(--c-text-3)",padding:4,borderRadius:8,lineHeight:1,display:"flex"}} aria-label="Close">
          <X size={20}/>
        </button>
        {intro && <p style={{fontSize:'var(--font-body)', fontWeight:400, color:'var(--c-text-2)', lineHeight:1.5, marginBottom:20, marginTop:0}}>{intro}</p>}
        <h2 style={{fontFamily:"var(--font-family-display)",color:"var(--c-heading)",margin:"0 0 20px",fontSize:'var(--font-h1)'}}>Why Go Premium?</h2>

        <div style={{marginBottom:20}}>
          <h3 style={{fontSize:'var(--font-body)',fontWeight:700,color:"var(--c-heading)",margin:"0 0 12px",textTransform:"uppercase",letterSpacing:"0.05em"}}>Premium includes</h3>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {premiumItems.map(item=>(
              <div key={item} style={{display:"flex",alignItems:"flex-start",gap:10}}>
                <Check size={16} color="var(--c-heading)" style={{flexShrink:0,marginTop:2}}/>
                <span style={{fontSize:'var(--font-body)',color:"var(--c-text)",lineHeight:1.5}}>{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{marginBottom:28}}>
          <h3 style={{fontSize:'var(--font-body)',fontWeight:700,color:"var(--c-text-2)",margin:"0 0 12px",textTransform:"uppercase",letterSpacing:"0.05em"}}>Free includes</h3>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {freeItems.map(item=>(
              <div key={item} style={{display:"flex",alignItems:"flex-start",gap:10}}>
                <Check size={16} color="var(--c-text-3)" style={{flexShrink:0,marginTop:2}}/>
                <span style={{fontSize:'var(--font-body)',color:"var(--c-text-2)",lineHeight:1.5}}>{item}</span>
              </div>
            ))}
          </div>
        </div>

        <button onClick={()=>alert("Premium subscriptions coming soon! Stay tuned.")}
          style={{background:"var(--c-heading)",color:"#fff",border:"none",borderRadius:24,padding:"12px 28px",fontSize:'var(--font-body)',fontWeight:700,cursor:"pointer",width:"100%",marginBottom:12}}>
          Upgrade to Premium
        </button>
        <div style={{textAlign:"center"}}>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",fontSize:'var(--font-small)',color:"var(--c-text-3)",textDecoration:"underline",padding:"4px 8px"}}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
